<template>
  <v-card
    :to="{name:'TextEdit', params:{novelid:encodeHash(item.item.novelId), text_id:encodeHash(item.item.id)}}"
    class="d-flex flex-column"
    flat
    min-height="150px"
    style="border-radius: 8px"
  >
    <v-card-title class="pb-2 pt-3">
      <v-list-item
        class="ma-0 pa-0 "
        dense
        style="width: 100%;"
      >
        <DragHandle
          v-if="originalSort"
          class="item-handle mx-0 px-2"
        />
        <v-list-item-icon class="ma-0 mt-2 pa-0">
          <FileIcon style="width: 22px;height: 27px" />
        </v-list-item-icon>

        <v-list-item-title
          class="ma-0 pa-0 mt-1"
        >
          <div
            v-if="user.pageFilterTitle"
            class="mx-4"
            style="font-size: 16px;font-weight: bold;opacity: 70%; text-overflow: ellipsis;overflow: hidden; white-space: nowrap;"
          >
            {{ item.item.name }}
          </div>
        </v-list-item-title>
        <v-list-item-action class="ma-0 pa-0">
          <v-icon
            v-if="checkedItems && checkedItems.indexOf(item)!=-1"
            color="secondary"
            @click.prevent="toggleItemCheck(item)"
          >
            mdi-checkbox-multiple-marked-circle
          </v-icon>
          <v-icon
            v-else
            color="textcolor"
            style="opacity: 0.7;"
            @click.prevent="toggleItemCheck(item)"
          >
            mdi-checkbox-multiple-marked-circle-outline
          </v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>

    <div class="griditem-border mr-4 ml-4" />
    <v-card-text class="mx-1 my-0 py-2">
      <v-clamp
        v-if="user.pageFilterDetail"
        :max-lines="1"
        autoresize
        class="pa-0 ma-0 "
        style="font-size: 12px;color: #797979;"
      >
        {{ item.item.content }}
      </v-clamp>
      <div
        v-if="user.pageFilterUpdate"
        class="d-flex align-center"
      >
        <ListIcon
          :style="`color: ${accentColor};width:6px;height:7px`"
          class="mr-1"
        />
        <div
          class="griditem-content-bold mr-3"
          style="padding-top:1px;"
        >
          最終更新日時
        </div>
        <div
          class="griditem-content"
          style="padding-top:1px;"
        >
          {{ item.item.updateDate |dayjs }}
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="ma-0 pa-0">
      <v-spacer />
      <v-btn
        :to="{name:'TextEdit', params:{novelid:encodeHash(item.item.novelId), text_id:encodeHash(item.item.id)}}"
        class="ma-0 mr-2"
        color="secondary"
        elevation="0"
        small
        tile
      >
        編集
      </v-btn>
      <v-btn
        class="ma-0"
        color="secondary"
        elevation="0"
        small
        tile
        @click.prevent="folderSelectDialog=true"
      >
        フォルダ移動
      </v-btn>
      <v-btn
        class="mr-3"
        icon
        @click.prevent="deleteItem(item)"
      >
        <DeleteIcon style="width: 20px;height: 25px;" />
      </v-btn>
    </v-card-actions>
    <v-card-actions>
      <v-spacer />
      <v-menu
        v-model="selectPreviewTypeMenu"
        offset-y
        rounded="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="text-button-small ma-0 pa-0 pr-2"
            text
            v-bind="attrs"
            x-small
            @click.prevent
            v-on="on"
          >
            <ListIcon
              :style="`color: ${accentColor};width:6px;height:7px`"
              class="mr-1"
            />
            プレビュー表示
          </v-btn>
        </template>
        <v-list
          class="pa-0"
          dense
        >
          <v-card-title
            class="ma-0 px-3 py-0"
            style="background-color:var(--v-primary-base); height:40px; font-size:13px;color:white;"
          >
            プレビューの表示方法を選択
          </v-card-title>
          <v-list-item
            dense
            :to="{name:'TextPreview', params:{novelid:encodeHash(item.item.novelId), text_id:encodeHash(item.item.id)}}"
          >
            <div>
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
              />このタブの中に表示
            </div>
          </v-list-item>
          <v-list-item
            dense
            @click.prevent="fullSizePreviewOpen(encodeHash(item.item.novelId),encodeHash(item.item.id),false)"
          >
            <div>
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
              />別窓で表示(横書き)
            </div>
          </v-list-item>
          <v-list-item
            dense
            @click.prevent="fullSizePreviewOpen(encodeHash(item.item.novelId),encodeHash(item.item.id),true)"
          >
            <div>
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
              />別窓で表示(縦書き)
            </div>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-model="selectRubiSiteTypeMenu"
        offset-y
        rounded="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="text-button-small ma-0 pa-0 pr-2"
            text
            v-bind="attrs"
            x-small
            @click.prevent
            v-on="on"
          >
            <ListIcon
              :style="`color: ${accentColor};width:6px;height:7px`"
              class="mr-1"
            />
            ルビ変換
          </v-btn>
        </template>
        <v-list
          class="pa-0"
          dense
        >
          <v-card-title
            class="ma-0 px-3 py-0"
            style="background-color:var(--v-primary-base); height:40px; font-size:13px;color:white;"
          >
            変換先ルビタイプ選択
          </v-card-title>
          <v-list-item
            v-for="(item,index) in siteTypes"
            :key="index"
            dense
            @click.prevent="convert(item)"
          >
            <div>
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
              />
              {{ item.label }} <span
                v-if="item.enableimage==true"
                class="optionItem"
              >挿絵○</span> <span
                class="optionItem"
              >{{ createRubiFormat(item) }}</span>
            </div>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn
        class="text-button-small ma-0 pa-0 pr-3"
        text
        x-small
        @click.prevent="textDownload(item)"
      >
        <ListIcon
          :style="`color: ${accentColor};width:6px;height:7px`"
          class="mr-1"
        />
        txtファイルでダウンロード
      </v-btn>
    </v-card-actions>
    <v-dialog
      v-model="rubiConvertDialog"
      max-width="790"
      scrollable
    >
      <ConvertRubi
        :id="item.item.id"
        :close="closeConvertDialog"
        :from-site-type="siteType"
        :to-site-type="toSiteType"
      />
    </v-dialog>
    <v-dialog
      v-model="folderSelectDialog"
      max-width="790"
      scrollable
    >
      <SelectFolder
        :change-folder-item="changeFolderItem"
        :current-folder-id="item.item.folderId"
        :folders="folders"
        :items="[item]"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import VClamp from 'vue-clamp'
import FileIcon from "@/component/svg/FileIcon";
import DeleteIcon from "@/component/svg/DeleteIcon";
import ListIcon from "@/component/svg/ListIcon";
import ConvertRubi from "@/component/ConvertRubi";
import SelectFolder from "@/component/SelectFolder";
import dayjs from "dayjs";
import config from "@/const";
import axios from "axios";
import firebase from "firebase/app";
import DragHandle from "@/component/DragHandle";
import {mapState} from "vuex";

export default {
  name: "PageCard",
  components: {
    VClamp,
    FileIcon,
    DeleteIcon,
    ListIcon,
    ConvertRubi,
    SelectFolder,
    DragHandle
  },
  filters: {
    dayjs: function (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm');
    }
  },
  props: ["item", "accentColor", "backgroundColor", "deleteItem", "novel", "folders", "changeFolderItemParent", "toggleItemCheck", "checkedItems","originalSort"],
  computed: {
    ...mapState({
      user: state => state.userModule.user,
    }),
  },
  data() {
    return {
      selectRubiSiteTypeMenu: false,
      selectPreviewTypeMenu:false,
      rubiConvertDialog: false,
      toSiteType: null,
      siteType: config.findSiteType(this.novel.targetSite),
      siteTypes: config.SITE_TYPE.filter((item) => item.value != this.novel.targetSite && item.rubiFormat),
      folderSelectDialog: false
    }
  },
  mounted() {
  },
  methods: {
    fullSizePreviewOpen(novelId, pageId,isVertical) {
      let resolvedRoute = this.$router.resolve({
        name: "FullSizeTextPreview",
        params: {
          novelid: novelId,
          text_id: pageId
        },
        query:{
          orientation:isVertical ? "vertical" : "horizontal"
        }
      });
      window.open(resolvedRoute.href, '_blank');
    },
    encodeHash: function (id) {
      return config.HASH_IDS.encode(id)
    },
    changeFolderItem(toFolderId, items) {
      if (toFolderId != null)
        this.changeFolderItemParent(toFolderId, items)
      this.folderSelectDialog = false
    },
    createRubiFormat(siteConfig) {
      return config.siteTypeString(siteConfig.value)
    },
    convert(siteType) {
      this.toSiteType = siteType
      this.rubiConvertDialog = true
    },
    closeConvertDialog() {
      this.rubiConvertDialog = false
    },
    async textDownload(novel) {

      const user = firebase.auth().currentUser;
      const token = await user.getIdToken(false);
      const ret = await axios.get(config.API_URL + "auth/page", {
        headers: {"X-Firebase-Auth": token},
        params: {
          "id": novel.item.id
        },
        data: {}
      });
      const item = ret.data;
      const fileName = `${item.name ? item.name : 'タイトル無し'}.txt`;
      const blob = new Blob([item.content], {'type': 'text/plain'});
      const isSaveBlob = window.navigator.msSaveBlob !== undefined;

      if (isSaveBlob) {
        window.navigator.msSaveBlob(blob, fileName);
        return;
      }

      const tempAnchor = document.createElement('a');
      tempAnchor.href = URL.createObjectURL(blob);
      tempAnchor.setAttribute('download', fileName);
      tempAnchor.dispatchEvent(new MouseEvent('click'));
    },

  },


}
</script>

<style scoped>
.optionItem {
  margin-left: 6px;
  padding: 2px;
  font-size: 11px;
  letter-spacing: 2px;
  background-color: #7D7D7D;
  color: #FFFFFF;
}
</style>
